module.exports = __webpack_public_path__ + "static/screen-day-3-e3d92a289cabc80331077ac1011c620a.png";